<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="p-2">
  <div class="fw-bold fs-5">Guest Profiles</div>
  <div class="guestProfileTable guest-profile-list">
    <p-table #pt [value]="guestProfiles" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="guestProfileId" selectionMode="single"
      [(selection)]="guestProfile" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
      [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
      currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
      sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped"
      [scrollable]="true" scrollHeight="calc(100vh - 220px)" [responsive]="true">

      <ng-template pTemplate="caption">
        <div class="flex justify-content-between">
          <div></div>
          <div class="d-block text-end">
            <span>
              <!--clear filters-->
              @if (showFilter) {
                <button pButton pRipple class="p-button-text"
                  style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
                (click)="reloadPage()">Clear Filters</button>
              }
              <app-import-export (dataAndTagsSelected)="dataAndTagSelected($event)" [tagsourceForInput]="50" [dataRetrived]="guestProfiles"
              (exportDataSelected)="exportSelected($event)" [sampleFileLink]="sampleLink" [columns]="columns"></app-import-export>
            </span>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          @for (col of columns; track col) {
            <th [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          }
          <th>Tags</th>
          <th></th>
        </tr>
        @if (showFilter) {
          <tr>
            <th><input style="width:100px;" pInputText type="text" (input)="pt.filter($event.target.value, 'firstName', 'in')"></th>
            <th><input style="width:100px;" pInputText type="text" (input)="pt.filter($event.target.value, 'lastName', 'in')"></th>
            <th><input style="width:150px;" pInputText type="text" (input)="pt.filter($event.target.value, 'emailAddress', 'in')"></th>
            <th><input style="width:120px;" pInputText type="text" (input)="pt.filter($event.target.value, 'mobilePhone', 'in')"></th>
            <th><input style="width:120px;" pInputText type="text" (input)="pt.filter($event.target.value, 'reservationVO.shortTermRentalVO.developmentVO.addressDevelopmentName', 'in')"></th>
            <th><input style="width:100px;" pInputText type="text" (input)="pt.filter($event.target.value, 'reservationVO.reservationStatus', 'in')"></th>
            <th><app-tag-join-filter-select [tagSource]="110" (getFilteredTags)="getFilteredTags($event)"></app-tag-join-filter-select></th>
            <th></th>
          </tr>
        }
      </ng-template>

      <ng-template pTemplate="body" let-guestProfile>
        <tr [pSelectableRow]="guestProfile">
          <td>{{guestProfile.firstName}}</td>
          <td>{{guestProfile.lastName}}</td>
          <td>{{guestProfile.emailAddress}}</td>
          <td>{{guestProfile.mobilePhone}}</td>
          <td>{{guestProfile.adrDevelopmentName}}</td>
          <td>{{getResStatusName(guestProfile)}}</td>
          <app-tag-join-list-select [tagSource]="110" [tagSourceId]="guestProfile.guestProfileId" tagType="4"></app-tag-join-list-select>
          <td><span style="float:none">
            <a>
              <i class="pi pi-pencil" aria-hidden="true"
              style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(guestProfile)"></i>
            </a>
          </span>
        </td>
      </tr>
    </ng-template>

  </p-table>
</div>
</div>
